import { render } from "./PrimaryButton.vue?vue&type=template&id=53473d99"
import script from "./PrimaryButton.vue?vue&type=script&setup=true&lang=js"
export * from "./PrimaryButton.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/PrimaryButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53473d99"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53473d99', __exports__)) {
    api.reload('53473d99', __exports__)
  }
  
  module.hot.accept("./PrimaryButton.vue?vue&type=template&id=53473d99", () => {
    api.rerender('53473d99', render)
  })

}


export default __exports__